import { isValidTextArea } from "@src/appV2/redesign/components/ValidatedTextArea";

export const CASE_DESCRIPTION_FIELD_NAME = "Description";
export const CASE_DESCRIPTION_MIN_LENGTH = 75;
export const CASE_DESCRIPTION_MAX_LENGTH = 2000;

export const CASE_DESCRIPTION_MIN_LENGTH_ERROR = `${CASE_DESCRIPTION_FIELD_NAME} must have at least ${CASE_DESCRIPTION_MIN_LENGTH} characters`;
export const CASE_DESCRIPTION_MAX_LENGTH_ERROR = `${CASE_DESCRIPTION_FIELD_NAME} must have at most ${CASE_DESCRIPTION_MAX_LENGTH} characters`;
export const CASE_DESCRIPTION_MIN_LENGTH_HINT = `Minimum ${CASE_DESCRIPTION_MIN_LENGTH} characters`;

/**
 * The description shown to professionals must be substantial enough to convey
 * the case's needs, so posting is gated on a 75-character minimum. Whitespace
 * is trimmed before counting.
 */
export function isCaseDescriptionValid(description: string): boolean {
  return isValidTextArea({
    value: description,
    minCharacters: CASE_DESCRIPTION_MIN_LENGTH,
    maxCharacters: CASE_DESCRIPTION_MAX_LENGTH,
  });
}

/**
 * Returns the relevant validation error for the description, or `undefined` when
 * it is valid. Distinguishes below-minimum from above-maximum so the field shows
 * the correct message. Whitespace is trimmed before counting.
 */
export function getCaseDescriptionError(description: string): string | undefined {
  const trimmedLength = description.trim().length;
  if (trimmedLength > CASE_DESCRIPTION_MAX_LENGTH) {
    return CASE_DESCRIPTION_MAX_LENGTH_ERROR;
  }

  if (trimmedLength < CASE_DESCRIPTION_MIN_LENGTH) {
    return CASE_DESCRIPTION_MIN_LENGTH_ERROR;
  }

  return undefined;
}

/**
 * Label for the live character counter shown beneath the description field. The
 * count reflects the trimmed length (what validation gates on) and is always
 * measured against the maximum, so the denominator unambiguously represents the
 * cap. The minimum requirement is communicated separately via the field hint.
 */
export function getCaseDescriptionCounterLabel(description: string): string {
  return `${description.trim().length}/${CASE_DESCRIPTION_MAX_LENGTH}`;
}
